import React, {Component} from 'react';
import NewsletterSignupForm from './NewsletterSignupForm'
import QuestionInfo from "./QuestionInfo";

export default class ModalQuestionInfo extends Component {
  constructor(props) {
      super(props);
  };

  closeModal = () => {
      this.props.closeModal();
  };

  componentWillMount = () => {
    document.body.classList.add("noScroll");
    document.documentElement.classList.add('noScroll');

    $("html, body").animate({ scrollTop: 0 }, "slow");
  }

  componentWillUnmount = () => {
    document.body.classList.remove('noScroll');
    document.documentElement.classList.remove('noScroll');
  };


  render() {
      return (
          <div className="share-popup">
            <span className="close" onClick={this.closeModal}></span>
            <QuestionInfo />
            <span className="confirm" onClick={this.closeModal}>OK</span>
          </div>
      );
  }
}



// WEBPACK FOOTER //
// ./src/components/ModalQuestionInfo.js